export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10710.6f3b14fc.jpg";